import React from 'react'

interface ProgressBarProps {
  currentStep: number
  totalSteps: number
}

/**
 * Horizontal progress bar for multi-step survey navigation.
 * Displays "Etapa X de Y" and a purple fill bar proportional to progress.
 */
const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps }) => {
  const percentage = Math.round((currentStep / totalSteps) * 100)

  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-slate-600">
          Etapa {currentStep} de {totalSteps}
        </span>
        <span className="text-sm text-slate-400">{percentage}%</span>
      </div>
      <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${percentage}%`,
            backgroundColor: '#7c3aed',
          }}
        />
      </div>
    </div>
  )
}

export default ProgressBar
